<template>
    <div class="row order-info">
        <div class="col-md-12">
            <div class="row align-items-start">
                <div class="col-sm-12 col-md-9">
                    <span
                        class="text-underline cursor-pointer text-muted"
                        style="position: absolute; top: -25px"
                        @click="$router.back()"
                        ><i class="fa fa-arrow-left" aria-hidden="true"></i> Go
                        back</span
                    >
                    <div class="d-flex align-items-center">
                        <h3 class="m-0 pr-2">Quote #{{ quoteInfo?.id }}</h3>
                        <span
                            class="px-1 view-action"
                            @click="editQuote(quoteInfo)"
                        >
                            (<i class="fa fa-pencil" aria-hidden="true"></i>
                            EDIT)
                        </span>
                        <!-- <span
                            v-if="
                                quoteInfo?.status.toLowerCase() ==
                                'pending approval'
                            "
                            class="px-1"
                            >|</span
                        >
                        <span
                            v-if="
                                quoteInfo?.status.toLowerCase() ==
                                'pending approval'
                            "
                            class="px-1 view-action"
                            @click="confirmDeleteModal(quoteInfo)"
                        >
                            <i class="fa fa-trash" aria-hidden="true"></i>
                            DELETE)
                        </span> -->
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <a
                        v-if="
                            (user.role.id == 1 || user.role.id == 4) &&
                            quoteInfo?.status == 'Approved'
                        "
                        :href="'/export-quote/' + quoteInfo?.id"
                        target="_blank"
                        class="btn add-button btn btn-action float-right"
                        >Export to PDF</a
                    >
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Dealer:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span
                                >{{ quoteInfo?.location?.name }}<br />
                                {{ quoteInfo?.location?.address }},
                                {{ quoteInfo?.location?.city }},
                                {{ quoteInfo?.location?.state }},
                                {{ quoteInfo?.location?.zip_code }}
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Date Created:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ quoteInfo?.created_at }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Created By:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ quoteInfo?.user.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Status:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span
                                class="px-4 py-2 mr-3 order-status"
                                :class="quoteInfo?.status.toLowerCase()"
                                >{{ quoteInfo?.status }}</span
                            >
                            <span
                                v-if="
                                    (user.role.id == 1 || user.role.id == 4) &&
                                    quoteInfo?.status == 'Pending Approval' &&
                                    !quoteInfo.quote_approved_by_user
                                "
                                class="add-button btn btn-action"
                                @click="confirmModal()"
                                >Approve Quote</span
                            >
                            <!-- <span
                                v-if="
                                    (user.role.id == 1 || user.role.id == 4) &&
                                    quoteInfo?.status == 'Approved'
                                "
                                class="add-button btn btn-action"
                                @click="confirmModalConvert()"
                                >Convert to Order</span
                            > -->
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="row mt-3">
                <div class="col-md-12">
                    <h5>Quote Items</h5>
                    <table class="table table-responsive table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th>Product Name</th>
                                <th style="width: 8em" class="text-right">
                                    SKU
                                </th>
                                <th style="width: 8em" class="text-right">
                                    MSRP
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Quantity
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Unit Price
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Unit Cost
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Total Revenue
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Pricebook Revenue
                                </th>
                                <th style="width: 8em" class="text-right">
                                    Total Cost
                                </th>
                                <th style="width: 8em" class="text-right">
                                    % OFF MSRP
                                </th>
                                <th style="width: 8em" class="text-right">
                                    GM %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in quoteInfo?.quote_items"
                                :key="item.id"
                            >
                                <td>
                                    <b>{{ item.product_name }}</b>
                                </td>
                                <td class="text-right">{{ item.sku }}</td>
                                <td class="text-right">
                                    ${{ $filters.moneyFormat(item.msrp) }}
                                </td>
                                <td class="mobile-text-right">
                                    {{ item.desired_quantity }}
                                </td>
                                <td class="mobile-text-right">
                                    ${{
                                        $filters.moneyFormat(
                                            item.desired_pricing
                                        )
                                    }}
                                </td>
                                <td class="mobile-text-right">
                                    ${{ $filters.moneyFormat(item.cost) }}
                                </td>
                                <td class="text-right">
                                    ${{
                                        $filters.moneyFormat(item.total_revenue)
                                    }}
                                </td>
                                <td class="text-right">
                                    ${{
                                        $filters.moneyFormat(
                                            item.msrp * item.desired_quantity
                                        )
                                    }}
                                </td>
                                <td class="text-right">
                                    ${{ $filters.moneyFormat(item.total_cost) }}
                                </td>
                                <td class="text-right">
                                    {{
                                        $filters.percentFormat(
                                            item.percent_off_msrp
                                        )
                                    }}%
                                </td>
                                <td class="text-right">
                                    {{ $filters.moneyFormat(item.gm_percent) }}%
                                </td>
                            </tr>
                            <tr>
                                <td class="subtotal text-right" colspan="6">
                                    <label>Total Gross Margin on Sale</label>
                                </td>
                                <td class="subtotal text-right">
                                    <span class="h6">
                                        ${{
                                            $filters.moneyFormat(
                                                totalGrossMarginOnSaleRevenue
                                            )
                                        }}
                                    </span>
                                </td>
                                <td class="subtotal text-right"></td>
                                <td class="subtotal text-right">
                                    <span class="h6">
                                        ${{
                                            $filters.moneyFormat(
                                                totalGrossMarginOnSaleCost
                                            )
                                        }}
                                    </span>
                                </td>
                                <td class="subtotal text-right" colspan="2">
                                    <span class="h6">
                                        {{
                                            $filters.percentFormat(
                                                totalGrossMarginOnSaleGMPercent
                                            )
                                        }}%
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-12 col-md-4">
                    <label>Internal Notes</label>
                    <p>{{ quoteInfo?.internal_notes }}</p>
                </div>
                <div class="col-sm-12 col-md-4">
                    <label>Dealer Notes</label>
                    <p>{{ quoteInfo?.dealer_notes }}</p>
                </div>
                <div class="col-sm-12 col-md-6"></div>
            </div>
        </div>
        <!-- Confirmation modal -->
        <b-modal v-model="modalShow" hide-footer>
            <Confirmation
                v-if="modalShow"
                :title="'Are you sure you want to approve this quote?'"
                @custom-func="updateOrderStatus"
                @close-modal="closeModal"
            />
        </b-modal>

        <!-- Convert Confirmation modal -->
        <b-modal v-model="modalShowConvert" hide-footer>
            <Confirmation
                v-if="modalShowConvert"
                :title="'Are you sure you want to convert this to order?'"
                @custom-func="convertQuoteToOrder"
                @close-modal="closeModalConvert"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import Confirmation from "@/components/Confirmation.vue";

export default {
    props: ["id"],
    emits: [],
    components: {
        Confirmation,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let quoteInfo = computed(function () {
            return store.state["quote"].quoteInfo;
        });

        onMounted(() => {});

        return {
            store,
            user,
            quoteInfo,
        };
    },
    data() {
        return {
            modalShow: false,
            modalShowConvert: false,
        };
    },
    computed: {
        totalGrossMarginOnSaleRevenue() {
            let total = 0;
            this.quoteInfo?.quote_items.forEach((data, idx) => {
                total += data.desired_quantity * data.desired_pricing;
            });
            return total;
        },
        totalGrossMarginOnSaleCost() {
            let total = 0;
            this.quoteInfo?.quote_items.forEach((data, idx) => {
                total += data.desired_quantity * data.cost;
            });
            return total;
        },
        totalGrossMarginOnSaleGMPercent() {
            let totalRevenue = 0;
            let totalCost = 0;
            let totalGM = 0;
            this.quoteInfo?.quote_items.forEach((data, idx) => {
                totalRevenue += data.desired_quantity * data.desired_pricing;
                totalCost += data.desired_quantity * data.cost;
            });
            totalGM = ((totalRevenue - totalCost) / totalRevenue) * 100;
            return totalGM;
        },
    },
    mounted() {
        if (this.user.quote_access || this.user.role.name == "quote_approver") {
            this.store.dispatch("quote/getQuoteById", this.id);
        } else {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        editQuote() {
            this.$router.push({
                name: "speqQuoteEdit",
                params: { id: this.id },
            });
        },
        confirmModal() {
            this.modalShow = !this.modalShow;
        },
        closeModal() {
            this.modalShow = !this.modalShow;
        },
        updateOrderStatus() {
            let request = {
                quote_id: this.id,
            };
            // this.quoteInfo.status =
            //     this.quoteInfo?.status == "Pending Approval"
            //         ? "Confirmed"
            //         : "Pending Approval";

            this.store
                .dispatch("quote/updateQuoteStatus", request)
                .then((resp) => {
                    this.store.dispatch("quote/getQuoteById", this.id);

                    window.emitter.emit("alertSuccess", {
                        message: "Quote has been approved successfully!",
                    });
                });
        },
        confirmModalConvert() {
            this.modalShowConvert = !this.modalShowConvert;
        },
        closeModalConvert() {
            this.modalShowConvert = !this.modalShowConvert;
        },
        convertQuoteToOrder() {
            axios
                .post("/api/convert-quote-to-order", { quote_id: this.id })
                .then((resp) => {
                    this.$router.push({
                        name: "speqOrderInfo",
                        params: { id: resp.data.order_id },
                    });

                    window.emitter.emit("alertSuccess", {
                        message:
                            "Quote has been converted to order successfully!",
                    });
                });
        },
    },
};
</script>
